import React from 'react';
import { ErrorMessageProps } from '../../types';
import './styles.css';

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  onRetry,
  size = 'medium',
  className = '',
  testId
}) => {
  return (
    <div 
      className={`error-container ${size} ${className}`} 
      data-testid={testId}
      role="alert"
    >
      <div className="error-content">
        <div className="error-icon" aria-hidden="true">!</div>
        <div className="error-text">
          <p>{message}</p>
          {onRetry && (
            <button 
              onClick={onRetry} 
              className="retry-button"
              type="button"
              aria-label="Try again"
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage; 